<mat-form-field appearence="fill" class="m-l-xs readonly-wrapper width-inherit" [floatLabel]="'never'">
    <mat-label class="{{labelCssClass}}">{{lablel}}</mat-label>
    <mat-select class="readonly-block" matNativeControl (selectionChange)="eventChange($event.value)" [disabled]="disable"
      [value]="value" class="font-size-16 position-relative" panelClass="dropdown-panel" disableOptionCentering>
      <ng-container *ngFor="let dropdownValue of dropdownValues">
        <mat-option value="{{dropdownValue?.value}}" class="font-size-16" [disabled]="dropdownValue?.value === value">{{dropdownValue?.displayText}}</mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>